module.exports = __webpack_public_path__ + "static/media/landingImg.a04c973c.png";